import React from 'react';
import './LandingModal.css';

const LandingModal = ({ open, handleClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-icon" onClick={handleClose}>
          ×
        </button>
        <h2 className="modal-title">
          <span className="title-line1">Admission Open</span>
          <span className="title-line2">2025-2026 Batch</span>
        </h2>
        <p className="modal-subtitle">Following Courses Available:</p>
        <ul className="modal-course-list">
          <li>B.E. - Computer Science and Engineering</li>
          <li>B.E. - Electrical and Electronics Engineering</li>
          <li>B.E. - Mechanical Engineering</li>
          <li>B.E. - Biomedical Engineering</li>
          <li>B.Tech. - Agricultural Engineering</li>
          <li>B.Tech. - Artificial Intelligence and Data Science</li>
          <li>B.Tech. - Information Technology</li>
        </ul>
      </div>
    </div>
  );
};

export default LandingModal;